import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { PayorFacilitiesService } from './payor-facilities.service';

@Component({
  selector: 'app-payor-facilities',
  templateUrl: './payor-facilities.component.html',
  styleUrls: ['./payor-facilities.component.scss']
})

export class PayorFacilitiesComponent implements OnInit {

  @Input() payorId: any;
  @Input() isPayorModule: boolean;
  @Input() isOrderingFacility: boolean;
  @Output() onSelectFacilityPayor?: EventEmitter<any> = new EventEmitter<any>();
  private gridFacilitysPayor: GridOptions;
  constructor(
    protected facilityPayorService: PayorFacilitiesService,
    private sweetAlertHelper: SweetAlertHelper,
    ) {
    const self = this;
    this.gridFacilitysPayor = <GridOptions> {
      enableSorting: true,
      enableColResize : true,
      sortingOrder: ['desc', 'asc', null]
    };
  }
  ngOnInit() {
    this.loadGrid();
    this.loadFacilitysPayor(this.payorId);
  }
  loadGrid() {
    const self = this;
    this.gridFacilitysPayor.columnDefs = [
      {
        headerName: 'Delete',
        field: 'delete',
        cellClass: 'fa fa-trash',
        cellStyle: {color: 'red', 'font-size': '15px', 'cursor' : 'pointer' },
        width: 30,
        hide:!self.isPayorModule,
        onCellClicked: function(params){
          self.deletePayorFacility(params.data.payorfacilityid);
        }
      },
      {headerName: 'Loc. Type', field: 'facility.facilitytype.modifier.description', width: 110},
      {headerName: 'Description', field: 'facility.description', width: 300},
      {headerName: 'Address', field: 'facility.streetaddress', width: 250},
      {headerName: 'Apt/Ste/Rm', field: 'facility.roomaptnumber', width: 90},
      {headerName: 'City', field: 'facility.city', width: 100},
      {headerName: 'State', field: 'facility.state', width: 90},
      {headerName: 'Zip Code', field: 'facility.zip', width: 90},
      {headerName: 'Lat', field: 'facility.latitude', width: 90},
      {headerName: 'Lng', field: 'facility.longitude', width: 90}
    ];
    this.gridFacilitysPayor.onGridReady     = function () {
      self.gridFacilitysPayor.api.sizeColumnsToFit();
    };
  }
  OnCellDoubleClicked($event) {
    if ( $event.data !== null ) {
      this.onSelectFacilityPayor.emit($event.data.facility);
    }
  }

  loadFacilitysPayor(payorId: number) {
    this.facilityPayorService.getFacilitysParyor(payorId, this.isOrderingFacility).subscribe(
      data => {
        const dataObj = data;
        if (this.gridFacilitysPayor) {
          if (this.gridFacilitysPayor.api) {
            this.gridFacilitysPayor.api.setRowData(dataObj);
          }
        }
      }
    );
  }
  onSelectFacilty4Payor(event) {
    const dataObj = {
      payorid: this.payorId,
      facilityid: event.facilityid,
      isactive: true,
      isOrderingFacility: this.isOrderingFacility
    };
    this.facilityPayorService.postFacilitysParyor(dataObj).subscribe(
      data => {
        this.loadFacilitysPayor(this.payorId);
      },
      er => this.sweetAlertHelper.createCustomAlert({title: 'Error', text: er.message, type: 'error'})
    );
  }
  deletePayorFacility(id) {
    this.facilityPayorService.deleteFacilitysParyor(id).subscribe(
      data => {
        this.loadFacilitysPayor(this.payorId);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/payors/payor-facilities/payor-facilities.component.ts